<template>
    <div class="tel"><v-icon size="18px">phone</v-icon>{{phone | i18n}}</div>
</template>


<script>

export default {
  components: { },
  props: { phone: String },
  data () {
    return {
    }
  },
  computed: {

  },
  methods: {
  },
  created() {
  },

  filters: {
	  	
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .tel {
        @include font-size(16px);
        width: fit-content;

        .v-icon {
            margin-right: 10px;
        }
    }
</style>